module.exports = __webpack_public_path__ + "static/img/feedback.884085e5.png";